export const COMMON_COURIER_PHARMACY_IDS = [
  // Capsule
  'phr_01GRGYMEZBF6516YSH8J88KACN',
  'phr_01GA9HPVQY0DKSW5G5YPS1KH93',
  'phr_01G9CM8XB71GYHQVFMZBXSVTBF',
  'phr_01GA9HPXPE3GH9Z05QV4SMKQEB',
  'phr_01GA9HPXNDYN4MVG2XDHKDYMTE',
  'phr_01GA9HPXF9E7DB4S3QJAT37AYD',
  'phr_01GA9HPXF93FNNA7TY5TMCCHED',
  'phr_01GA9HPXEYZ0R4BDJYAV9X4FNB',
  'phr_01GA9HPX8W2SNZ4WZDF2QN3HAV',
  'phr_01GA9HPX5XAV6FXG5TNNGZ2KRW',
  'phr_01GA9HPX5R5VS4D95XHSKZTFJ0',
  'phr_01GA9HPX4BTXBJDRGRBZQ6W6GW',
  'phr_01GA9HPX48G27SCD3REFE9ZM6G',
  'phr_01GA9HPX3S85T10VTV4VV9T52W',
  'phr_01GA9HPX0HJDK7YWE3AX8VVJ53',
  'phr_01GA9HPWZRHQF8BZ5J9SQZKYRN',
  'phr_01GA9HPWY8K1EZTQM3K6EJZDAP',
  'phr_01GA9HPWV48P7XCXC2E8YBPFX9',
  'phr_01GA9HPWRTAQ8Y4RBWEY3JJK4Q',
  'phr_01GA9HPWP4J2AKFDK02ACCM9VX',
  'phr_01GA9HPWDZECXHRMR72SH9KHBS',
  'phr_01GA9HPVXFMVA7KJ21MRF3TSEN',
  'phr_01GA9HPVV8FHY4204CTDXAV3M0',
  'phr_01GA9HPVEDG5F5MRM1G0WEH65P',
  'phr_01GA9HPVCAF1Y2D5307JGF16BK',
  'phr_01GA9HPVARX6TMMZY0GMB5NB3N',
  'phr_01GA9HPV5YDASCR5MD4NX00XQZ',
  'phr_01GA9HPV3G7WPD0MFMAM4W1DYQ',
  'phr_01GA9HPVNMT7VBWG09D6FAC0RP',
  // Alto
  'phr_01GA9HPXNGYD3YZQ1AZBREN4M4',
  'phr_01GA9HPXNE1X7VSYR4SD7HBDBR',
  'phr_01GA9HPXM26ZPAY8AVBE1YADMZ',
  'phr_01GA9HPXD68240FHX282QH251Q',
  'phr_01GA9HPX91JXAB4XQWEWXY16X3',
  'phr_01GA9HPX8VF3A2Y2YC3HDSZ2JC',
  'phr_01GA9HPX7CYVKC87QFTAXYKYA8',
  'phr_01GA9HPW0BCXEGA3WWTPSADRT0',
  'phr_01GA9HPVC68G1VY232JYDGQA3F',
  'phr_01GA9HPV3GWF9AS544ABDD01YJ',
  'phr_01G9CM93X1NFP1C9H9K50DPKHX'
];
